<template>
  <div id="app">
    <!-- 公用头部导航栏 -->
    <div class="nav" ref="nav">
      <div class="nav_wrap">
        <h1>
          <img  src="./assets/imges/p1_logo.png"/>
        </h1>
        <ul class="nav_menu">
          <div>
            <router-link to="/" tag="li" :class="{show1:csluss===''}">
              <a>首页</a>
            </router-link>
            <router-link to="/scheme" tag="li" :class="{show1:csluss==='scheme'}">
              <a>线上展厅</a>
            </router-link>
            <router-link to="/modeling" tag="li" :class="{show1:csluss==='modeling'}">
              <a>3D建模</a>
            </router-link>
            <router-link to="/PanoramicLive" tag="li" :class="{show1:csluss==='PanoramicLive'}">
              <a>全景直播</a>
            </router-link>
            <router-link to="/cases" tag="li" :class="{show1:csluss==='cases'}">
              <a>精品案例</a>
            </router-link>
            <router-link to="/coordinates" tag="li" :class="{show1:csluss==='coordinates'}">
              <a>关于我们</a>
            </router-link>
             <router-link to="/Participation" tag="li" :class="{show1:csluss==='Participation'}">
              <a>展商加盟</a>
            </router-link>
          </div>
        </ul>
        <div class="search_app">
          <h3 ref="h2">
            <img  src="./assets/imges/contact.png"/>
            400-930-1887
          </h3>
        </div>
      </div>
      <div class="Sign_in">
        <ul>
          <li><a href="https://cms.3dyunchuang.com/admin/login/index" target = "blank">登录</a></li>
          <li>|</li>
          <li><a href="https://cms.3dyunchuang.com/admin/login/index" target = "blank">注册</a></li>
        </ul>
      </div>
    </div>
    <!-- 咨询弹窗 -->
    <div class="consulting_service" v-if="zxindex">
      
      <a href="https://tb.53kf.com/code/client/2c9ac8eb206a33d7b6f7100dbaedc3334/1" target="_blank">
      <img src="./assets/imges/2.png"/>
      </a>
      <div class="zxdispnone" @click="zxnone"></div>
    </div>
    <BackThetop></BackThetop>
    <!-- 渲染组件 -->
    <router-view/>
  </div>
</template>
<script>
import BackThetop from '@/common/public/Back_thetop'
export default {
  name: 'App',
  data() {
    return {
      input: '',
      csluss: "",
      logop:false,
      zxindex:true,
      t1:""
    }
  },
  components:{
    BackThetop
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        //监控hash 值切换calss.
        this.csluss = val.path.slice(1);
        //localStorage.setItem("messs",this.csluss)        //存起来
      },
      deep: true
    }
  },
  mounted() {
    var str = window.location.hash.slice(1);
    this.csluss = str.substr(1);
    window.addEventListener("scroll", this.getScrollposition, false);
  },
  destroyed() {
    //监听完毕 离开结束
    localStorage.clear();
    window.removeEventListener("scroll", this.getScrollposition, false);
  },
  methods:{
     getScrollposition(e) { 
       var consulting_service = document.querySelectorAll(".consulting_service")[0]
      if(this.zxindex){
          consulting_service.style.opacity = "0.4"
        setTimeout(function(){
            consulting_service.style.opacity = "1"
        },800)
      }
    },
    zxnone(){
      this.zxindex = false
      var thi_s = this
      this.t1 = setTimeout(function(){
        thi_s.zxindex = true

          clearInterval(thi_s.t1)

      },60000)
    }
  }
}
</script>
<style>

*{
  padding: 0px;
  margin: 0PX;
}
ul,li{
  list-style: none;
}
a{
  text-decoration: none;

}
.show1{
  border-bottom: 2px solid #357eff;
}
.show1 a{
  color: #357eff!important; 
  line-height: 53px!important;
}
.apco{
  color: #fff!important;

}
.nav{
  width: 100%;
  z-index: 888;
  position: fixed;
  top: 0;
  left: 0;
  height: 55px;
  background:rgba(25,25,25,0.95);
  transition: 0.5s all;
}
.nav_menu li{
  float: left;
  margin-right: 20px;
}
.nav_menu li:last-child{
  margin-right: 0;
}
.nav_menu li a{
  width: 86px;
  font-size: 14px;
  display: block;
  color: #fff;
  text-align: center;
  line-height: 55px;
}
.nav_wrap{
  width:1202px;
  height: 55px;
  margin: 0px auto;
}
.nav_wrap h1{
  float: left;
  width: 136px;
  height: 100%;
  margin-top: 8px;
  margin-right: 66px;
}
.nav_wrap h1 img{
  width: 132px!important;
  height: 38px!important;
}
.Sign_in{
  width: 110px;
  height: 32px;
  position: absolute;
  right: 60px;
  top: 12px;
  /* background: rgba(25,25,25,.5); */
  border-radius: 4px;
  padding-left: 13px;
  color: #fff;
}
.Sign_in a{
  color: #fff;
}
.Sign_in ul li{
  float: left;
  line-height: 32px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  margin-right: 15px;
}
.search_app{
  width: 270px;
  float: right;
  height: 55px;
}
.search_app h3{
  width: 280px;
  float: left;
  margin: 0;
  line-height: 60px;
  color: #fff;
}
.search_app h3 img{
  float: left;
  margin-left: 110px;
  margin-top:15px;
  width: 28px;
  height: 28px;
}
.consulting_service{
  width: 11.25%;
  position: fixed;
  left: 9px;
  bottom:0%;
  z-index: 11;
  display: block;
}
.consulting_service img{
  width: 100%;
  cursor: pointer;
}
.zxdispnone{
  position: absolute;
  right: 0%;
  top: 0px;
  width: 25px;
  height: 25px;
  cursor: pointer;
  /* background: red; */
}
@media screen and (max-width: 1552px) {
  .search_app{
    display: none;
  }
  .Sign_in{
    right: 126px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue